import moment from 'moment'

export const utcHelper = (date: Date | undefined | string | null) => {
  if (date) {
    return moment(date).add(moment().utcOffset(), 'minutes').toDate()
  }
  return undefined
}

export const periodsToCommas = (months: string): string => months.toString().replace('.', ',')

//export const convertMonthsToWorkingDays = (months: number): number => Math.round(months * 20)

/**
 * Formats a date into a Helsinki timezone date-time string (always fi-FI locale).
 * Falls back to '-' when value is missing / invalid.
 * @param dateLike original date value (string | Date | null | undefined)
 * @param emptyFallback value returned when date is empty/invalid (default '-')
 */
export const formatHelsinkiDateTime = (dateLike: Date | string | null | undefined, emptyFallback = '-'): string => {
  if (!dateLike) return emptyFallback
  const date = utcHelper(dateLike)
  if (!date) return emptyFallback
  const formatted = new Intl.DateTimeFormat('fi-FI', {
    timeZone: 'Europe/Helsinki',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
    .format(date)
    .replace(',', '')
  return formatted
}
